import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { LoadingGuard, usePagedListing, useSafeSistaAsync, } from "@sista/library-stasi";
import { useCallback, useMemo, useState } from "react";
import { DataGridPro, } from "@mui/x-data-grid-pro";
import { useNavigate } from "react-router-dom";
import { useSpravaTextuClient } from "../../util/useSpravaTextuClient";
import { findDefaultTexts } from "./TextsTable";
const pageSize = 100;
export const DictionaryTable = ({ canEdit, }) => {
    const { t } = useTranslation("sprava-textu");
    const spratex = useSpravaTextuClient();
    const [getAllTextsCall, getAllTextsState] = useSafeSistaAsync(spratex.findTexts);
    const [filterValue, setFilterValue] = useState(null);
    const navigate = useNavigate();
    const paramsForFilter = useMemo(() => {
        if (filterValue == null || filterValue.length === 0) {
            return {};
        }
        //console.log("FILTER VALUE", filterValue);
        // Convert filterValue to the expected format
        const params = filterValue?.map((item) => {
            if (item.field === "namespace") {
                return {
                    namespaceQuery: item.value,
                };
            }
            if (item.field === "key") {
                return {
                    keyQuery: item.value,
                };
            }
            if (item.field === "state") {
                return {
                    states: item.value,
                };
            }
            if (item.field === "taggerIds") {
                return {
                    taggerIds: item.value,
                };
            }
            if (item.field === "cs") {
                return {
                    translationsQuery: item.value,
                };
            }
            if (item.field === "en") {
                return {
                    translationsQuery: item.value,
                };
            }
            return {};
        });
        if (params.length === 1) {
            return params[0];
        }
        if (params.length > 1) {
            const joinedParams = params.join(",").trim();
            return joinedParams;
        }
    }, [filterValue]);
    const loader = useCallback(async (page) => {
        const result = await getAllTextsCall({
            page: page,
            pageSize: pageSize,
            flags: ["DICTIONARY"],
            ...paramsForFilter,
        });
        if (result == null) {
            return [];
        }
        return result;
    }, [getAllTextsCall, paramsForFilter]);
    const { currentPage, error, pending, refresh, rows } = usePagedListing({
        loader,
        maxRows: 10000,
    });
    const onFilterChange = useCallback((filterModel) => {
        // Here you save the data you need from the filter model
        if (filterModel == null ||
            filterModel.items == null ||
            filterModel.items.length == 0) {
            if (filterValue == null) {
                // no change
                return;
            }
            setFilterValue(null);
            refresh();
            return;
        }
        //console.log("FILTER MODEL", filterModel);
        let f = filterModel.items.map((item) => {
            return {
                field: item.field,
                operator: item.operator,
                value: item.value,
            };
        });
        if (f.length == 0)
            f = null;
        if (f == filterValue) {
            // no change
            return;
        }
        setFilterValue(f);
        refresh();
    }, [filterValue, refresh]);
    const columns = useMemo(() => {
        return [
            {
                field: "cs",
                headerName: t("sprava-textu.textsTable.cs", "Česky"),
                sortable: true,
                flex: 1,
                valueGetter: (params) => {
                    const text = findDefaultTexts(params.row);
                    if (text == null)
                        return "";
                    return text.translations?.cs ?? "";
                },
            },
            {
                field: "en",
                headerName: t("sprava-textu.textsTable.en", "English"),
                sortable: true,
                flex: 1,
                valueGetter: (params) => {
                    const text = findDefaultTexts(params.row);
                    if (text == null)
                        return "";
                    return text.translations?.en ?? "";
                },
            },
            {
                field: "key",
                headerName: t("sprava-textu.textsTable.key", "Klíč"),
                sortable: true,
                flex: 1,
            },
        ].filter(Boolean);
    }, [t]);
    return (_jsx(LoadingGuard, { state: getAllTextsState, children: _jsx(DataGridPro, { rows: rows, getRowId: (row) => row.namespace + "|" + row.key, columns: columns, 
            //onFilterModelChange={onFilterChange}
            onRowClick: (params) => {
                return navigate(`/keys/${params.row.namespace}|${params.row.key}`);
            }, density: "compact", pageSizeOptions: [pageSize] }) }));
};
